module.exports = __webpack_public_path__ + "static/img/eureka_tall.1b6c56d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/content/about/images/eureka_tall.svg
// module id = Lj5t
// module chunks = 1